/**
 * Include your custom JavaScript here.
 */

/* Announcement */
$(document).ready(function() {
  setInterval(function() {
    $('.offer').first().slideUp(function(){
        $(this).appendTo($(this).parent()).css({ overflow: '', display: '' });
      });
  }, 4400);

  $('.site-nav__dropdown').on('mouseenter',function(){
    $('body').addClass('no-scroll-menu');
  });
  $('.site-nav__dropdown').on('mouseleave',function(){
    setTimeout(function(){
      $('body').removeClass('no-scroll-menu');
    },400);
  });

  $('.mobile-nav__link--top-level.collapsible-trigger').on('click',function(){
    $('#NavDrawer').toggleClass('is-active');
  });

  $('body').on('click','[data-layout]',function(){
    $(this).parent().find('[data-layout]').removeClass('is-active');
    $(this).addClass('is-active');
    $('[data-grid-layout]').attr('data-grid-layout',$(this).data('layout'));
    $.cookie('layout', $(this).data('layout'), { expires: 20 });
  });

  if($.cookie('layout')) {
    $('[data-layout]').removeClass('is-active');
    $('[data-layout="'+$.cookie('layout')+'"]').addClass('is-active');
    $('[data-grid-layout]').attr('data-grid-layout',$.cookie('layout'));
  }

  $('body').on('click','[data-blog-view]',function(){
    $(this).parent().find('[data-blog-view]').removeClass('is-active');
    $(this).addClass('is-active');
    $('[data-view-article]').attr('data-view-article',$(this).data('blog-view'));
  });

  $('body').on('click','[data-option-id]',function(){
    var optionValue = $(this).parent().find('label').html();
    var optionColor = $(this).parent().find('.variant_swatch-color').html();
    var productId = $(this).data('option-id');
    var optionName = $(this).attr('name').toLowerCase();
    var buttonTrigger = $('[aria-controls="group-'+optionName+'-'+productId+'"]');
    buttonTrigger.find('[data-value]').html(optionValue);
    console.log(optionColor);
    buttonTrigger.find('[data-color]').html(optionColor);

    setTimeout(function(){
      buttonTrigger.trigger('click');
      
      if(!$('#AddToCart-'+productId).hasClass('disabled')) {
        $('.error-'+productId).addClass('hide');
        $('.variant-check-'+productId).removeClass('show');
        $('.variant-check-'+productId).addClass('hide');
      }
    },100);
    
  });

  $('body').on('click','[data-variant-id]',function(){
    var Id = $(this).data('id');
    var price = $(this).data('variant-price');
    console.log(price);
    $('[data-product-id="'+Id+'"]').find(".bc-sf-filter-product-item-regular-price").html(price);
    $('[data-product-id="'+Id+'"]').find(".bc-sf-filter-product-item-sale-price").html(price);
    $('[data-product-id="'+Id+'"]').find('[data-variant-color-image]').removeClass('is-active');
    $(this).parent().find('[data-variant-id]').removeClass('is-active');
    $('[data-variant-color-image="'+$(this).data('variant-id')+'"').addClass('is-active');
    $(this).addClass('is-active');
  });

  $('body').on('click','[data-product-id]',function(){
    $('#AddToCartForm-'+$(this).data('product-id')).find('.size-error').removeClass('hide');
  });

  $(window).on('scroll',function(){
    var height = window.innerHeight / 2;
    var scroll = window.scrollY;

    if (scroll > height) {
      $('[data-scroll-top]').addClass('active');
    } else {
      $('[data-scroll-top]').removeClass('active');
    }
  });

  $('body').on('click','[data-scroll-top] a',function(){
    $('html, body').animate({ scrollTop: 0 }, 500);
  });

  $('.collect-deliver-buttons button').click(function(elem) {
    elem.preventDefault();
    
    $(this).siblings().removeClass('active');
    if( !$(this).hasClass('active') ) {
      $(this).addClass('active');
    }

    if( $(this).hasClass('collect') && $(this).hasClass('active') && !$('#ClickAndCollect').is(":checked") ) {
      $('#ClickAndCollect').click();
    } else if( $(this).hasClass('deliver') && $('#ClickAndCollect').is(":checked") ) {
      $('#ClickAndCollect').click();
    }
  });

  $(window).scroll(function() {
    if( $('header').hasClass('site-header--stuck') ) {
      $('body').addClass('header-sticky');
    } else {
      $('body').removeClass('header-sticky');
    }
  })

});

function FreeShippingCheck(total_price) {
  document.querySelector('.go-cart-drawer__shipping').style.display = 'block';

  if (dynamic_free_shipping) {
      var cart_price = total_price / 100;

      if (cart_price > free_shipping_minimum) {
        document.querySelector('.go-cart-drawer__shipping div').classList.add('free-shipping');
        document.querySelector('.go-cart-drawer__shipping div').innerHTML = '<img src="'+ free_shipping_icon_white +'" alt="Free shipping icon" /> ' + dynamic_free_shipping_success;
      }
      else {
        var amount_to_free_shipping = free_shipping_minimum - cart_price;
        document.querySelector('.go-cart-drawer__shipping div').classList.remove('free-shipping');
        document.querySelector('.go-cart-drawer__shipping div').innerHTML = '<img src="'+ free_shipping_icon +'" alt="Free shipping icon" /> <span class="amount-to-fs">$' + amount_to_free_shipping.toFixed(2) + '</span> ' + dynamic_free_shipping_alert; 
      }
  }
  else {
      document.querySelector('.go-cart-drawer__shipping div').classList.add('free-shipping');
      document.querySelector('.go-cart-drawer__shipping div').innerHTML = static_free_shipping_message;
  }

  const cartItems = document.querySelectorAll('.go-cart-item__single');
  const cartHeader = document.querySelector('.go-cart-drawer__header');
  let offset = cartHeader.offsetHeight;
  cartItems.forEach((element) => {
    offset += element.offsetHeight;
  });
  document.querySelector('.go-cart-drawer__shipping').style.top = `${offset + 50}px`;
}
